export type HomeContentLayout = 'fullScreen' | 'scrollable';

export const defaultHomeContentLayout: HomeContentLayout = 'scrollable';
